import actHttp from '@/utils/actHttp'

export default {
    // 登录
    login: (params) => {
      return actHttp.post('/minifire-july/api/v1/login', params)
    },
    // 获取公共配置（含活动道具、每日奖励、累充档位、见面礼配置）
    getCommonConfig: (params) => {
      return actHttp.post('/minifire-july/api/v1/get-common-config', params)
    },
    // 获取用户详情
    getUserDetail: (params) => {
      return actHttp.post('/minifire-july/api/v1/get-user-detail', params)
    },
    // 领取见面礼
    receiveWelcomeReward: (params) => {
      return actHttp.post('/minifire-july/api/v1/receive-welcome-reward', params)
    },
    // 领取每日奖励（一次领取全部可领奖励，不含见面礼）
    receiveDailyReward: (params) => {
      return actHttp.post('/minifire-july/api/v1/receive-daily-reward', params)
    },
    // 领取累充奖励（一次领取全部可领奖励，不含见面礼）
    receiveAccumulateRechargeReward: (params) => {
      return actHttp.post('/minifire-july/api/v1/receive-accumulate-recharge-reward', params)
    },
    // 统一领取全部可领奖励（不含见面礼）
    receiveAllRewards: (params) => {
      return actHttp.post('/minifire-july/api/v1/receive-all-rewards', params)
    },
    // 兑换头像框
    exchangeReward: (params) => {
      return actHttp.post('/minifire-july/api/v1/exchange-reward', params)
    },
    // 统一领取记录
    getRewardRecord: (params) => {
      return actHttp.post('/minifire-july/api/v1/get-reward-record', params)
    },
}